import React, { useEffect, useState } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";

import img1 from '../../../assets/images/ImagenesTooltipReportes/RP001.png'
import img2 from '../../../assets/images/ImagenesTooltipReportes/RP002.png'
import img3 from '../../../assets/images/ImagenesTooltipReportes/RP003.png'
import img4 from '../../../assets/images/ImagenesTooltipReportes/RP004.png'
import img5 from '../../../assets/images/ImagenesTooltipReportes/RP005.png'
import img6 from '../../../assets/images/ImagenesTooltipReportes/RP006.png'
import img7 from '../../../assets/images/ImagenesTooltipReportes/RP007.png'
import img8 from '../../../assets/images/ImagenesTooltipReportes/RP008.png'
import ReactTooltip from "react-tooltip";


const clasePestania =
    "border-x border-t rounded-t-md py-2 w-[90px] bg-gray-600 flex-shrink-0 text-sm flex flex-wrap justify-center";

export const ConsultasReportes = () => {
    const jsonMenus = [
        {
            nomMenu: "RP001",
            nombreReporte: "Alcaldes",
            imageMenu: img1
        },
        {
            nomMenu: "RP002",
            nombreReporte: "Centros poblados",
            imageMenu: img2

        },
        {
            nomMenu: "RP003",
            nombreReporte: "Incidencias general",
            imageMenu: img3

        },
        {
            nomMenu: "RP004",
            nombreReporte:
                "Incidencias por departamento,distrito y provincia",
            imageMenu: img4

        },
        {
            nomMenu: "RP005",
            nombreReporte: "Incidencias por tipo",
            imageMenu: img5

        },
        {
            nomMenu: "RP006",
            nombreReporte: "Incidencias por estado",
            imageMenu: img6

        },
        {
            nomMenu: "RP007",
            nombreReporte: "Centros poblados por departamento",
            imageMenu: img7

        },
        {
            nomMenu: "RP008",
            nombreReporte: "Estado Situacional",
            imageMenu: img8

        },
        {
            nomMenu: "RP009",
            nombreReporte: "Condiciones basicas",
            imageMenu: ""

        },
    ];

    const [menuActual, setMenuActual] = useState("HOME");
    const [menusAbiertos, setMenusAbiertos] = useState([]);
    const [componentes, setComponentes] = useState([]);

    useEffect(() => {
        cargarComponentes();
    }, []);

    const funcionAbrirMenu = (nombreMenu) => {
        if (!menusAbiertos.some((elem) => elem == nombreMenu)) {
            setMenuActual(nombreMenu);
            setMenusAbiertos((arrAnterior) => {
                return [...arrAnterior, nombreMenu];
            });
        }
    };

    const cargarComponentes = async () => {
        const nuevosComponentes = await Promise.all(
            jsonMenus.map(async (data) => {
                try {
                    const modulo = await import(
                        `./VistaReportes/${data.nomMenu}`
                    );
                    return {
                        nomMenu: data.nomMenu,
                        nomReporte: data.nombreReporte,
                        componente: modulo.default,
                        error: null, // No hay error
                    };
                } catch (error) {
                    // CUANDO NO TRAE NADA EL IMPORT
                    console.error(`Error importing ${data.nomMenu}:`, error);
                    return {
                        nomMenu: data.nomMenu,
                        nomReporte: data.nombreReporte,
                        componente: null,
                        error: error.message, // Mensaje de error
                    };
                }
            })
        );
        setComponentes(nuevosComponentes);
    };

    return (
        <>
            <div className="overflow-auto flex-grow flex flex-col mt-2">
                <div className="flex gap-1">
                    <button
                        className={`${clasePestania} ${
                            menuActual == "HOME" ? "!bg-blue-600" : ""
                        }`}
                        onClick={() => setMenuActual("HOME")}
                    >
                        HOME
                    </button>
                    {menusAbiertos.map((nombreMenu, i) => (
                        <button
                            key={i + 1}
                            className={`${clasePestania} relative ${
                                menuActual == nombreMenu ? "!bg-blue-600" : ""
                            }`}
                            onClick={() => setMenuActual(nombreMenu)}
                        >
                            <span>{nombreMenu}</span>
                            <div
                                onClick={(event) => {
                                    event.stopPropagation(); // EVITA QUE SE EJECUTE EL ONCLICK DEL BOTON
                                    setMenuActual("HOME");
                                    setMenusAbiertos((arrAnterior) => {
                                        const arrCopia = [...arrAnterior];
                                        return arrCopia.filter(
                                            (e) => e != nombreMenu
                                        );
                                    });
                                }}
                                className="absolute z-10 top-0 right-0 rounded-full w-[16px] h-[16px] flex items-center justify-center bg-red-600 hover:scale-105"
                            >
                                <i
                                    className="fa fa-times text-[10px]"
                                    aria-hidden="true"
                                ></i>
                            </div>
                        </button>
                    ))}
                </div>
                <div className="flex-grow overflow-auto border border-gray-500 p-2 flex flex-col">
                    {/* MENU HOME */}
                    <div
                        className={`${
                            menuActual == "HOME" ? "" : "hidden"
                        } w-full h-full overflow-auto containerScroll flex flex-col p-6`}
                    >
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-left">Nº</th>
                                    <th className="text-left">CÓDIGO</th>
                                    <th className="text-left">TÍTULO</th>
                                    <th className="text-left">NOMBRE</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {jsonMenus.map((data, i) => {
                                    return (
                                        <tr
                                            key={i + 1}
                                            onClick={() =>
                                                funcionAbrirMenu(data.nomMenu)
                                            }
                                            className={`${
                                                menusAbiertos.some(
                                                    (e) => e == data.nomMenu
                                                )
                                                    ? "!bg-[#5985eb]"
                                                    : ""
                                            }`}
                                        >
                                            <td className="text-left">
                                                {i + 1}
                                            </td>
                                            <td className="text-left">
                                                {data.nomMenu}
                                            </td>
                                            <td className="text-left">
                                                {data.nombreReporte}
                                            </td>
                                            <td className="text-left">
                                                {data.nombreReporte}
                                            </td>
                                            <td>
                                                <i data-tip data-for={`imageTooltip_${data.nomMenu}`} className="fa fa-picture-o text-xl" aria-hidden="true"></i>
                                                <ReactTooltip 
                                                    id={`imageTooltip_${data.nomMenu}`} 
                                                    place="left" 
                                                    effect="solid" 
                                                    // type="light"
                                                >
                                                    <img src={data.imageMenu} className="w-[600px]" alt="https://via.placeholder.com/150" />
                                                </ReactTooltip>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    {/* MENUS RESTANTES */}
                    {componentes.map(
                        (
                            {
                                nomMenu: nomMenu,
                                nomReporte: nombreReporte,
                                componente: ComponenteDinamico,
                            },
                            i
                        ) =>
                            menuActual == nomMenu ? (
                                <div
                                    key={i + 1}
                                    className={`${
                                        menuActual == nomMenu ? "" : "hidden"
                                    } w-full h-full flex-grow flex flex-col`}
                                >
                                    <ComponenteDinamico
                                        nombreReporte={nombreReporte}
                                    />
                                </div>
                            ) : (
                                <React.Fragment key={i + 1}></React.Fragment>
                            )
                    )}
                </div>
            </div>
        </>
    );
};
